import apiClient from '../../../Services/ApiClient';

export const getAddFamilyMemberAvailability = (userId: string) => {
	return apiClient.get(`/patients/${userId}/family/available`);
};

export const getCanAddFamilyMember = async (
	userId: string,
): Promise<boolean> => {
	const { data } = await getAddFamilyMemberAvailability(userId);
	return !!(data?.adults || data?.children);
};
